export class DeactivateAccountResponse {
    'deactivated';
    'remainingCredits';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "deactivated",
            "baseName": "deactivated",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "remainingCredits",
            "baseName": "remainingCredits",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return DeactivateAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
